import React from "react";
import iconRar from "../../img/icons-ext-file/iconRar.png"

export default function FileRar() {
    return (
        <img src={iconRar} alt="" />
    );
}